import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import productData from '../data/productData';
import './ProductDetails.css';

const ProductDetails = () => {
    const { productId } = useParams();
    const navigate = useNavigate();
    const product = productData[productId];
    const [selectedImageIndex, setSelectedImageIndex] = useState(0);

    const handleBackToProducts = () => {
        navigate('/');
        setTimeout(() => {
            const productsSection = document.getElementById('products');
            if (productsSection) {
                productsSection.scrollIntoView({ behavior: 'smooth', block: 'start' });
            }
        }, 100);
    };

    useEffect(() => {
        window.scrollTo(0, 0);
        setSelectedImageIndex(0); // Reset to first image when product changes
    }, [productId]);

    if (!product) {
        return (
            <div className="product-details-page">
                <div className="container">
                    <h2>Product not found</h2>
                    <button className="btn btn-primary" onClick={handleBackToProducts}>
                        Back to Products
                    </button>
                </div>
            </div>
        );
    }

    const handleWhatsAppOrder = () => {
        const whatsappNumber = '919625588537';
        const message = encodeURIComponent(product.whatsappMessage);
        const whatsappUrl = `https://wa.me/${whatsappNumber}?text=${message}`;
        window.open(whatsappUrl, '_blank');
    };

    return (
        <div className="product-details-page">
            <div className="container">
                <button className="btn-back" onClick={handleBackToProducts}>
                    <span>←</span> Back to Products
                </button>

                <div className="product-details-content">
                    <div className="product-image-section">
                        <div className="image-gallery">
                            <div className="main-image-container">
                                <img
                                    src={product.images ? product.images[selectedImageIndex] : product.image}
                                    alt={product.title}
                                    className="product-detail-image"
                                />
                            </div>
                            {product.images && product.images.length > 1 && (
                                <div className="thumbnail-container">
                                    {product.images.map((img, index) => (
                                        <div
                                            key={index}
                                            className={`thumbnail ${selectedImageIndex === index ? 'active' : ''}`}
                                            onClick={() => setSelectedImageIndex(index)}
                                        >
                                            <img src={img} alt={`${product.title} view ${index + 1}`} />
                                        </div>
                                    ))}
                                </div>
                            )}
                        </div>
                    </div>

                    <div className="product-info-section">
                        <h1 className="product-detail-title">{product.title}</h1>
                        <p className="product-detail-description">{product.description}</p>

                        <div className="info-dashboard">
                            <div className="info-card">
                                <h3>Key Benefits</h3>
                                <ul className="info-list">
                                    {product.benefits.map((benefit, index) => (
                                        <li key={index}>
                                            <span className="check-icon">✓</span>
                                            {benefit}
                                        </li>
                                    ))}
                                </ul>
                            </div>

                            {product.bestFor && (
                                <div className="info-card">
                                    <h3>Best For</h3>
                                    <ul className="info-list">
                                        {product.bestFor.map((item, index) => (
                                            <li key={index}>
                                                <span className="check-icon">✓</span>
                                                {item}
                                            </li>
                                        ))}
                                    </ul>
                                </div>
                            )}

                            <div className="info-card">
                                <h3>Usage Guidance</h3>
                                <ul className="info-list">
                                    {product.usage.map((item, index) => (
                                        <li key={index}>
                                            <span className="check-icon">✓</span>
                                            {item}
                                        </li>
                                    ))}
                                </ul>
                            </div>

                            {product.whyUse && (
                                <div className="product-why-use">
                                    <h3>Why Choose Growing Fields Organics?</h3>
                                    <p>{product.whyUse}</p>
                                </div>
                            )}
                        </div>

                        <button className="btn-whatsapp" onClick={handleWhatsAppOrder}>
                            <span>Order via WhatsApp</span>
                            <span className="whatsapp-icon">→</span>
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ProductDetails;
